var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.list),function(item,index){return _c('el-breadcrumb-item',_vm._b({key:index},'el-breadcrumb-item',index===0 ? { to: { path: '/' + item.path } } : {},false),[_vm._v(_vm._s(item.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }